import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AdminRedirectGuard implements CanActivate {
  canActivate(): boolean {
    // Porta de emergência: acessar o admin ANTIGO sem redirect.
    // No console do navegador:
    //   localStorage.setItem('adminAccessOverride', 'true')   // libera o admin antigo
    //   localStorage.removeItem('adminAccessOverride')         // volta a redirecionar
    if (localStorage.getItem('adminAccessOverride') === 'true') {
      return true;
    }

    // Redireciona /admin para o novo backoffice (aplicação externa).
    // A URL vem por ambiente de src/environments (token #{backofficeUrl}# no release).
    window.location.href = environment.BACKOFFICE_URL;
    return false;
  }
}
